import { FolderOpen } from 'lucide-react';

// Shared "No Project Selected" empty state used by the access-matrix screens
// (WebAccessPage and MobileAccessTab). Both pages inlined this exact markup —
// a `space-y-6` wrapper around a dashed-border card with a FolderOpen icon,
// the "No Project Selected" heading, and a single help paragraph. The only
// difference between the two sites was the help text, exposed here as the
// `message` prop so each call renders byte-identically to its original inline
// block.
interface NoProjectSelectedStateProps {
  /** The help paragraph shown under the heading. WebAccessPage passes
   *  "Select a project from the dropdown in the menu bar to manage roles."
   *  and MobileAccessTab passes
   *  "Select a project from the dropdown in the menu bar." */
  message: string;
}

export function NoProjectSelectedState({ message }: NoProjectSelectedStateProps) {
  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-dashed border-gray-300 bg-white py-16 text-center">
        <FolderOpen className="mx-auto h-12 w-12 text-gray-300" />
        <h3 className="mt-4 text-lg font-medium text-gray-600">No Project Selected</h3>
        <p className="mt-2 text-sm text-gray-400">{message}</p>
      </div>
    </div>
  );
}

export default NoProjectSelectedState;
